import { filterEmptySpecs } from '../technical-specs/TechnicalSpecsClass'
import { COMPARADOR_REMOVE_ITEMS_TO_COMPARE } from './constants'
import initialState from './initialState'
import { getInitialRelevantAttributes } from '../relevant-attributes/relevantAttributesClass'

export function removeItemsToCompare(index) {
    return {
        type: COMPARADOR_REMOVE_ITEMS_TO_COMPARE,
        index
    }
}

export function reducer(state = initialState, action) {
    const { index, type } = action

    if (type === COMPARADOR_REMOVE_ITEMS_TO_COMPARE) {
        let schema = [...state.schema]
        const tecSpecs = state.technicalSpecs.filter((_d, i) => i !== index)

        schema.splice(index, 1)

        if (index === 0 && !schema[index].isFormCompleted) schema[index].isFormVisible = true

        const defaultCard = {
            ...initialState.schema[1],
            isFormDisabled: !schema.some(s => !!s.isFormCompleted),
        }

        schema = [...schema, defaultCard]

        schema.forEach((s, i) => {
            s.isFormDisabled = !schema[i - 1]?.isFormCompleted
            s.reloadAt = new Date().getMilliseconds()
        })

        return {
            ...state,
            schema,
            technicalSpecs: filterEmptySpecs(tecSpecs),
            relevantAttributes: getInitialRelevantAttributes(schema),
        }
    } else {
        return state
    }
}
